import type GetCalendarFoldersResponse from 'owa-service/lib/contract/GetCalendarFoldersResponse';
import type { SessionData } from 'owa-service/lib/types/SessionData';

let responseFromSessionData: GetCalendarFoldersResponse;

export function stashCalendarFoldersFromSessionData(
    sessionData: SessionData | undefined
): SessionData {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (12,5): Type 'GetCalendarFoldersResponse | undefined' is not assignable to type 'GetCalendarFoldersResponse'.
    // @ts-expect-error
    responseFromSessionData = sessionData?.getCalendarFolders;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (16,5): Type 'SessionData | undefined' is not assignable to type 'SessionData'.
    // @ts-expect-error
    return sessionData;
}

export function getCalendarFoldersFromSessionData(): GetCalendarFoldersResponse {
    let response = responseFromSessionData;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (24,5): Type 'undefined' is not assignable to type 'GetCalendarFoldersResponse'.
    // @ts-expect-error
    responseFromSessionData = undefined;
    return response;
}
